module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/close03-e01421d5088c4501e864f5268d9ffe02.svg";